// extracted by mini-css-extract-plugin
export var borderTop = "_v-3";
export var linkIcon = "_v-5";
export var linkIconSm = "_v-6";
export var linkOutCard = "_v-7 _v-4";
export var linkRow = "_v-2";
export var pageContainer = "_v-1";
export var providerIcon = "_v-8";
export var roundedBorder = "_v-4";
export var settingsContent = "_v-0";